document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.testimonial-slider');
  if (!slider) return;
  
  let currentIndex = 0;
  const items = slider.querySelectorAll('.testimonial-item');
  const prevButton = slider.querySelector('.testimonial-prev');
  const nextButton = slider.querySelector('.testimonial-next');
  const dotsContainer = slider.querySelector('.testimonial-dots');
  
  // 점(Dots) 생성
  items.forEach((_, index) => {
    const dot = document.createElement('button');
    dot.classList.add('testimonial-dot');
    dot.setAttribute('aria-label', `후기 ${index + 1}로 이동`);
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => goToSlide(index));
    dotsContainer.appendChild(dot);
  });
  
  const dots = dotsContainer.querySelectorAll('.testimonial-dot');
  
  function showSlide(index) {
    items.forEach((item, i) => {
      if (i === index) {
        item.classList.add('active');
        item.style.display = 'block';
      } else {
        item.classList.remove('active');
        item.style.display = 'none';
      }
    });
    
    dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }
  
  function nextSlide() {
    currentIndex = (currentIndex + 1) % items.length;
    showSlide(currentIndex);
  }
  
  function prevSlide() {
    currentIndex = (currentIndex - 1 + items.length) % items.length;
    showSlide(currentIndex);
  }
  
  function goToSlide(index) {
    currentIndex = index;
    showSlide(currentIndex);
  }
  
  // 이벤트 리스너
  if (prevButton) {
    prevButton.addEventListener('click', prevSlide);
  }
  
  if (nextButton) {
    nextButton.addEventListener('click', nextSlide);
  }
  
  // 초기 슬라이드 표시
  showSlide(0);
  
  // 자동 재생 (5초마다)
  let autoplayInterval = setInterval(nextSlide, 5000);
  
  // 사용자가 상호작용하면 자동 재생 재설정
  slider.addEventListener('click', function() {
    clearInterval(autoplayInterval);
    autoplayInterval = setInterval(nextSlide, 5000);
  });
});
